const testimonies = [
  {
    photoUrl: '',
    testimony: `Il a été particulièrement agréable d'accompagner David pour son parcours de formation de Développeur d'applications Android chez OpenClassrooms.
        Son travail fût toujours réalisé avec soin, que ce soit pour les projets de développement ou pour les projets de conception et documentation.
        David fait preuve d’une extrême autonomie, d'une forte capacité d'analyse pour effectuer ses choix de conception et de toutes les qualités et la curiosité nécessaires pour être en veille active sur le développement d'applications, ce qui lui a permis de sélectionner avec soin et de mettre en œuvre des architectures modernes ainsi que d'utiliser des librairies avancées pour la réalisation de ses projets.
        S'il est certain que ses acquis techniques sont importants, David a également su se démarquer lors de sa formation par sa capacité à retranscrire son travail au cours de chaque soutenance de projet auprès des différents évaluateurs de la formation.
        Je ne peux que recommander David pour la qualité des projets qu'il réalise.`,
    source: {
      name: 'LinkedIn',
      linkUrl: 'https://www.linkedin.com/in/david-dekeuwer-1940a01b9/',
    },
    name: 'Denis',
    type: 'Mentor',
  },
  {
    photoUrl: '',
    testimony:
      "Besoin d'un ajout de fonctionnalité pour l'une de mes applications android, David a réalisé le travail efficacement et rapidement ! Je recommande...",
    source: {
      name: 'Malt',
      linkUrl: 'https://www.malt.fr/profile/daviddekeuwer',
    },
    name: 'WGI Gaming',
    type: 'Client',
  },
  {
    photoUrl: '',
    testimony: `J'ai évalué David dans le cadre de sa formation pour devenir développeur d'applications sur Android. Je le recommande pour la qualité de son travail et son professionnalisme.`,
    source: {
      name: 'LinkedIn',
      linkUrl: 'https://www.linkedin.com/in/david-dekeuwer-1940a01b9/',
    },
    name: 'Grégoire',
    type: 'Évaluateur',
  },
];

export default testimonies;
